export enum SystemRole {
  AccountAdmin = "account_admin",
  SystemAdmin = "system_admin",
  SecurityAdmin = "security_admin",
  Public = "public",
}

export const SUPPORT_ROLE_NAME = "firebolt_support";

export const RBAC_NAME_TYPE_MAP = {
  [SystemRole.AccountAdmin]: SystemRole.AccountAdmin,
  [SystemRole.SystemAdmin]: SystemRole.SystemAdmin,
  [SystemRole.SecurityAdmin]: SystemRole.SecurityAdmin,
  [SystemRole.Public]: SystemRole.Public,
};
